import React from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import { theme } from "../constants/theme";
import CssBaseline from "@material-ui/core/CssBaseline";
import { GeneralModal, SortButtonAndMenu } from "../components-molecules";
import { ClusteredList } from "../components-organisms";
import { HeaderWithButtons } from "../components-molecules";
import {
  addNewCollection,
  getCollectionsSymbols,
  getCollectionsSymbolsWithParams,
} from "../redux/actions/getCollections";
import { useDispatch, useSelector } from "react-redux";
import searchicon from "../assets/icons/searchicon.png";
import { useEffect } from "react";
import { CircularProggressIndicator } from "../components-atoms";
// import { setError } from "../redux/actions/error";

const CollectionList = (props: any) => {
  const classes = useStyles();
  const [sortType, setSortType] = React.useState("Asc");
  const [newCollectionName, setNewCollectionName] = React.useState("");
  const [nameError, setNameError] = React.useState(false);
  const [openSearch, setOpenSearch] = React.useState(false);
  const [searchTerm, setSearchTerm] = React.useState("");
  // const [filter, setFilter] = React.useState<{
  //   Verticals: Array<string>;
  //   Categories: Array<string>;
  // } | null>(null);
  // const [filterType, setFilterType] = React.useState("");
  const dispatch = useDispatch();
  const [openAddShopModal, setAddOpenShopModal] =
    React.useState<boolean>(false);

  const [collectionsData, loading] = useSelector((state: any) => [
    state.CollectionSymbolsReducer.data,
    state.CollectionSymbolsReducer.loading,
  ]);

  useEffect(() => {
    dispatch(getCollectionsSymbols());
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getCollectionsSymbolsWithParams(
        searchTerm ? searchTerm : "",
        sortType.trim() === "" ? "Asc" : sortType,
        null
      )
    );
  }, [sortType, dispatch, searchTerm]);

  const handleSubmit = () => {
    if (newCollectionName.trim() === "") {
      setNameError(true);
      return;
    }

    const body = {
      Name: newCollectionName,
    };
    dispatch(
      addNewCollection(body, null, () => {
        setNewCollectionName("");
        setAddOpenShopModal(false);
      })
    );
  };

  const bottomTextCreator = React.useCallback((item: any) => {
    return `${
      item?.CategoryCount
        ? item.CategoryCount + item.CategoryCount === 1
          ? " Category · "
          : " Categories · "
        : ""
    }${
      item?.BrandCount
        ? item.BrandCount + item.BrandCount === 1
          ? " Brand · "
          : " Brands · "
        : ""
    }${
      item?.MerchantCount
        ? item.MerchantCount + item.MerchantCount === 1
          ? " Merchant · "
          : " Merchants · "
        : ""
    }${
      item?.ProductCount
        ? item.ProductCount + item.ProductCount === 1
          ? " Product · "
          : " Products · "
        : ""
    }`;
  }, []);

  const topTextCreator = React.useCallback(
    (item: any) => `${item?.Name ?? "Unnamed Collection"}`,
    []
  );

  const pathCreator = React.useCallback(
    (item: any) => `/admin/collection/${item.Id}`,
    []
  );

  function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  const debounceFunction = (st: string, order: string) =>
    debounce(() => {
      dispatch(getCollectionsSymbolsWithParams(st ? st : "", order, null));
    }, 300);

  const performSearch = React.useCallback(debounceFunction, [dispatch]);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    performSearch(event.target.value, sortType);
  };

  const updateList = ({ search, order, filter }) => {
    dispatch(
      getCollectionsSymbolsWithParams(search ? search : "", order, null)
    );
  };

  return (
    <Box className={classes.container}>
      <CssBaseline />
      <Container className={classes.root}>
        <CssBaseline />
        <HeaderWithButtons>
          <HeaderWithButtons.ButtonArea>
            <div className={classes.mgLeftAuto}>
              <SortButtonAndMenu
                menuItems={[
                  {
                    title: "Alphabetical ascending",
                    value: "Asc",
                    handleSelect: () => {
                      setSortType("Asc");
                      updateList({
                        search: "",
                        order: "Asc",
                        filter: null + "",
                      });
                    },
                  },
                  {
                    title: "Alphabetical descending",
                    value: "Desc",
                    handleSelect: () => {
                      setSortType("Desc");
                      updateList({
                        search: "",
                        order: "Desc",
                        filter: null + "",
                      });
                    },
                  },
                ]}
                selectedSortType={sortType}
              />
              <Button
                id="basic-button"
                aria-controls="basic-menu"
                aria-haspopup="true"
                onClick={() => setOpenSearch(true)}
              >
                <img
                  src={searchicon}
                  className={classes.buttonIcon}
                  alt="printIcon"
                />
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setAddOpenShopModal(true);
                }}
                style={{ paddingLeft: props.loading ? "12px" : "16px" }}
              >
                Add Collection
              </Button>
            </div>
          </HeaderWithButtons.ButtonArea>
        </HeaderWithButtons>
        {/* CSS FIX : margin-left: auto */}

        {openSearch && (
          <Grid container className={classes.searchBarArea}>
            <Grid item xs={11}>
              <TextField
                style={{ width: "100%" }}
                variant="outlined"
                name="Search"
                placeholder="Search Subcategory"
                label="Search"
                value={searchTerm}
                onChange={handleSearch}
              ></TextField>
            </Grid>
            <Grid item xs={1} className={classes.searchCancelButtonArea}>
              <Button
                id="basic-button"
                aria-controls="basic-menu"
                aria-haspopup="true"
                onClick={() => {
                  setSearchTerm("");
                  setOpenSearch(false);
                }}
                className={classes.modalImageText}
              >
                {/* <img src={printIcon} className={classes.buttonIcon} alt="printIcon" /> */}
                <Typography
                  variant="button"
                  component="span"
                  color="primary"
                  className={classes.printButtonText}
                  onClick={() => {
                    setSearchTerm("");
                    updateList({
                      search: "",
                      order: sortType,
                      filter: null + "",
                    });
                  }}
                >
                  Cancel
                </Typography>
              </Button>
            </Grid>
          </Grid>
        )}
        {loading ? (
          <CircularProggressIndicator />
        ) : (
          <ClusteredList
            data={collectionsData ?? []}
            bottomTextCreator={bottomTextCreator}
            topTextCreator={topTextCreator}
            pathCreator={pathCreator}
            headlineTypeSingular="Collection"
            headLineTypePlural="Collections"
          />
        )}
      </Container>
      <GeneralModal
        title="Add Collection"
        description="Start by giving category a name, upload an image and write a short description.Once added you will be able to add subSubcategorys from Subcategorys details screen."
        visible={openAddShopModal}
        onClose={setAddOpenShopModal}
        onSubmit={handleSubmit}
        modalWidth="560px"
      >
        <GeneralModal.ContentArea>
          <Grid container>
            <Grid item xs={12}>
              <TextField
                placeholder="Collection Name"
                value={newCollectionName}
                variant="outlined"
                margin="normal"
                fullWidth
                id="CollectionName"
                label="Collection Name"
                name="CollectionName"
                onChange={(event: any) =>
                  setNewCollectionName(event.target.value)
                }
                error={nameError}
                InputProps={{
                  classes: {
                    root: classes.cssOutlinedInput,
                    focused: classes.cssFocused,
                    notchedOutline: classes.notchedOutline,
                  },
                }}
              />
            </Grid>
          </Grid>
        </GeneralModal.ContentArea>
        <GeneralModal.ButtonArea>
          <Button
            onClick={() => {
              setAddOpenShopModal(false);
            }}
            className={classes.cancelButton}
          >
            <Typography
              onClick={() => {
                setNameError(false);
                setNewCollectionName("");
                setAddOpenShopModal(false);
              }}
              variant="button"
              component="p"
              color="primary"
            >
              Cancel
            </Typography>
          </Button>
          <Button onClick={handleSubmit} className={classes.submitButton}>
            <Typography variant="button" component="p" color="inherit">
              Submit
            </Typography>
          </Button>
        </GeneralModal.ButtonArea>
      </GeneralModal>
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  buttonIcon: {
    width: "18px",
    height: "18px",
    marginRight: 8,
  },
  root: {
    flexGrow: 1,
    maxWidth: "840px",
  },
  tabContainer: {
    backgroundColor: theme.palette.background.paper,
    paddingBottom: "8px",
  },
  mgLeftAuto: {
    display: "flex",
    flexDirection: "row",
  },
  submitButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  cancelButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.light,
    marginRight: "8px",
  },
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,

    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  modalImageText: { display: "inline-block", verticalAlign: "middle" },
  modalImageTextArea: { display: "flex", alignItems: "center" },
  printButtonText: {
    textTransform: "none",
  },
  searchCancelButtonArea: {
    display: "flex",
    alignItems: "center",
  },
  searchBarArea: {
    marginTop: 25,
  },
  selectArea: { width: "100%", marginBottom: 15 },
});

export default CollectionList;
